import { useMemo } from 'react';

import { MantineColor, MantineSize, resolveClassNames } from '@mantine/core';

import { uiTheme } from '../theme';

interface UseMergeClassNamesProps {
  styleCtx?: Record<string, string>;
  // TODO: type this!
  classNames: any;
  props?: Record<string, any>;
}

export const MANTINE_COLORS: MantineColor[] = [
  'primary',
  'secondary',
  'success',
  'danger',
  'black',
  'blue',
  'creamorange',
  'cyan',
  'dark',
  'grape',
  'gray',
  'green',
  'indigo',
  'lime',
  'orange',
  'pink',
  'purple',
  'red',
  'teal',
  'text',
  'violet',
  'white',
  'yellow'
];

export const MANTINE_SIZES: MantineSize[] = ['xs', 'sm', 'md', 'lg', 'xl'];

export const MANTINE_POSITIONS = [
  'bottom-end',
  'bottom-start',
  'top-end',
  'top-start',
  'bottom-center',
  'top-center',
  'middle-center',
  'middle-end',
  'middle-start'
];

export const MANTINE_VARIANTS = ['default', 'filled', 'unstyled'];

export const MANTINE_FONT_WEIGHTS = [400, 500, 600, 700, 800];

export const MANTINE_TEXT_ALIGNMENTS = [
  'left',
  'right',
  '-moz-initial',
  'inherit',
  'initial',
  'revert',
  'unset',
  'center',
  'end',
  'start',
  'justify',
  'match-parent'
];

export const MANTINE_TEXT_TRANSFORMS = [
  '-moz-initial',
  'inherit',
  'initial',
  'revert',
  'unset',
  'none',
  'capitalize',
  'full-size-kana',
  'full-width',
  'lowercase',
  'uppercase'
];

export const useMergeClassNames = ({
  classNames,
  props,
  styleCtx
}: UseMergeClassNamesProps) =>
  useMemo(
    () =>
      resolveClassNames({
        classNames: classNames,
        theme: uiTheme,
        stylesCtx: styleCtx,
        props: props || {}
      }),
    [classNames, props, styleCtx]
  );
